/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'

import { BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import Body from '../../Typography/Body/Body'
import Link from '../../Typography/Link/Link'
import Button from '../../Buttons/Button'
import { Fragment } from 'react'

const Text = ({ children }) => (
  <Body variant="body2" sx={{ marginY: '15px' }}>
    {children}
  </Body>
)

const options = text => ({
  [BLOCKS.PARAGRAPH]: (node, children) => <Text>{children}</Text>,
  [BLOCKS.QUOTE]: (node, children) => (
    <Text as="blockquote" sx={{ fontStyle: 'italic' }}>
      {children}
    </Text>
  ),
  [BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
    const block = text.references.find(
      r => r.contentful_id === node.data.target.sys.id
    )

    if (block.__typename === 'ContentfulActionButton') {
      return (
        <Button
          variant={block.buttonStyle || 'black'}
          size={block.buttonSize || 'medium'}
          to={block.toSlug}
          sx={{ mt: 10 }}
        >
          {block.buttonLabel}
        </Button>
      )
    }
    return <Fragment />
  },
  [BLOCKS.EMBEDDED_ASSET]: node => {
    if (!node.data.target.fields) {
      return <Fragment />
    }
    const { title, description, file } = node.data.target.fields
    const mimeType = file['en-US'].contentType
    const mimeGroup = mimeType.split('/')[0]

    const imageSize = {
      width: file['en-US'].details.image.width / 2,
      height: file['en-US'].details.image.height / 2,
    }

    switch (mimeGroup) {
      case 'image':
        return (
          <img
            title={title ? title['en-US'] : null}
            alt={description ? description['en-US'] : null}
            src={file['en-US'].url}
            sx={{
              ...imageSize,
              margin: ['10px auto', '10px auto', '20px auto'],
            }}
          />
        )
      case 'application':
        return (
          <a
            alt={description ? description['en-US'] : null}
            href={file['en-US'].url}
          >
            {title ? title['en-US'] : file['en-US'].details.fileName}
          </a>
        )
      default:
        return (
          <span style={{ backgroundColor: 'red', color: 'white' }}>
            {' '}
            {mimeType} embedded asset{' '}
          </span>
        )
    }
  },

  [INLINES.HYPERLINK]: node => {
    return (
      <Link
        sx={{
          display: 'inline',
          letterSpacing: '1.5px',
          textDecoration: 'underline',
        }}
        to={node.data.uri}
      >
        {node.content[0].value}
      </Link>
    )
  },
})

const ContentfulRichText = ({ text, customOptions = {} }) => {
  return (
    <>
      {documentToReactComponents(JSON.parse(text.raw), {
        renderNode: {
          ...options(text),
          ...customOptions,
        },
        renderText: text => {
          return text.split('\n').reduce((children, textSegment, index) => {
            return [...children, index > 0 && <br key={index} />, textSegment]
          }, [])
        },
      })}
    </>
  )
}
export default ContentfulRichText
